(function ($) {
  // What does the dropdown plugin do?
  $.fn.dropDown = function (options) {
    if (!this.length) {
      return this;
    }

    var opts = $.extend(true, {}, $.fn.dropDown.defaults, options);

    var dropDownList = this.find('.js-dropdown');

    $('.js-dropdown-choices [data-dropdownchoice]').click(function () {
      var newValue = $(this).attr('data-dropdownchoice');
      var $parent = $(this).parents('.js-dropdown');
      $parent.find('.js-dropdown-value').html(newValue);
      $parent.removeClass('is-open');
    });

    $('.js-dropdown-value').click(function () {
      var $parent = $(this).parents('.js-dropdown');
      $parent.toggleClass('is-open');
    });

    return this;
  };

  // default options
  $.fn.dropDown.defaults = {};
})(jQuery);
